import history from '../../../../history';
import { showFormatedDate, showFormattedTime, showFormatedDateandTime, alertConfirmation, extractNameFromArray, HELPINGHANDS,showFormatedDateandTimeForSessionLogs } from '../../../../actions/utilAction';
import { Field, reduxForm } from 'redux-form';
import { getAppointmentById, getPatientEncounter, savePatientEncounter, saveClockInTimeIntoAppointment, saveClockOutTimeIntoAppointment} from './actions/soapActions';
import { getAppConfigList, getGeoLocation, getGeoLocationClockIn, getGeoLocationClockOut } from '../../../AppConfig/actions';
import React, { Component } from 'react';
import { renderAutoCompleteSingleSelect, renderTextArea, renderTimePicker } from '../../../../components/reduxFields';
import { CancelButton, CommonButton } from '../../../../components/buttons';
import { connect } from 'react-redux';
import moment from 'moment';
//import PatientInfo from '../../../patients/patient_info';
import SignatureModal from './signature_modal';
import Alert from 'react-s-alert';
import SignatureWithSuperviseeModal from './signatureWithSupervisee_modal';
import { getStaffTrainingTitlesForHIH } from './../SessionNotes_HIH/actions/soapActions';
import SessionAuditLogModal from '../../SessionAuditLogModal';

const validateTrainingTitleId = (value) => (!value || !Number.isInteger(value)) ? 'Please select training title.' : undefined;
const validateNonBillableNotes = (value) => !value ? 'Please enter Notes.' : undefined;

class Soap extends Component {
  constructor(props) {
    super(props);
    this.state = ({
      fixedHeader: true,
      height: '200px',
      selectable: false,
      fixedFooter: false,
      DateTimeOfVisit: '',
      patientObj: [],
      master_data: props.master_data,
      firstName: '',
      middleName: '',
      lastName: '',
      fullName: '',
      patient_id: null,
      apptid: parseInt(props.match.params.apptId, 10),
      encounterId: parseInt(props.match.params.encId, 10),
      isAdminUpdateAfterRendered: parseInt(props.match.params.isAdminUpdate, 10),
      isGenerateClaimAfterRendered: parseInt(props.match.params.isGenerateClaim, 10),
      staffID: null,
      appointmentDate: '',
      actualStartTime: '',
      actualEndTime: '',
      staffName: '',
      patientName: '',
      payerName: '',
      appointmentTypeName: '',
      appointmentTypeIsBillable: false,
      genderID: null,
      diagnosisArray: [],
      PatientLocationID: null,
      PatientLocationName: '',
      open: false,
      openCPT: false,
      openSign: false,
      soapPage: false,
      attachment: [],
      icdArray: [],
      DateOfService: '',
      attachedDiagnosisArray: [],
      get_soap: null,
      serviceStartTime: '',
      serviceEndTime: '',
      appointment: null,
      ParentAppointmentID: null,
      appointmentStartDateTime: '',
      appointmentEndDateTime: '',
      serviceFacility: '',
      isDirectService: '',
      CPTTableData: [],
      EmployeeSign: { id: 0, Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      ClientSign: { id: 0, Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      GuardianSign: { id: 0, Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },      
      SuperviseeSign: { id: 0, Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      signRequired: {
        employee_sign: false,
        client_sign: false,
        guardian_sign: false,
        supervisee_sign: false,
      },
      showCompleteButton: false,
      isAllSigned: false,
      isSoapCompleted: false,
      signatureStaffs: [],
      clockInDateTime: '',
      clockOutDateTime: '',
      timeDifference: 0.0,
      supervisionTrainingTitleWithoutOJT :  props.supervisionTrainingTitleWithoutOJT ? props.supervisionTrainingTitleWithoutOJT : [], 
      openSessionAuditLogModal: false,     
      lastUpdatedBy: '',
      lastUpdatedDate: '',
    });
    this.filter = {
      isClientSigned: false,
      isEmployeeSigned: false,
      isGuardianSigned: false,      
      isSuperviseeSigned: false,
    };
    this.onDateChange = this.onDateChange.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.onCompleteEncounter = this.onCompleteEncounter.bind(this);
  };

  componentWillMount() {
    if(this.props.agencyName.toUpperCase() === HELPINGHANDS)
    {
      this.props.getStaffTrainingTitlesForHIH(this.state.apptid, this.state.encounterId, true);
    }
    
    //this.props.getMasterData();
    if (this.state.apptid) {
      // this.props.getAppointmentById(this.state.apptid);
      let isAdminUpdateAfterRendered = this.state.isAdminUpdateAfterRendered ? true : false;
      this.props.getPatientEncounter(this.state.apptid, this.state.encounterId, isAdminUpdateAfterRendered);
    }
    this.props.getAppConfigList();
  }

  handleCancel() {
    history.push('/scheduling');
  }

  handleAlertClick = (event) => {
    this.setState({clockInDateTime : moment.utc().format('YYYY-MM-DDTHH:mm:ss')},()=>{ this.props.getGeoLocationClockIn(); });    
    Alert.closeAll();
  };

  handleClockIn = (event) => {
    let warningMsg = 'Are you sure you want to clock-in ? You can only do it once. You should be at the location where session is taking place';
    alertConfirmation(warningMsg, {
      html: true,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertClick       
      },
    });
  };

  handleOpenSessionAuditLog = (event) => {    
    this.setState({
      openSessionAuditLogModal: true     
    });
  }

  handleCloseSessionAuditLogModal = () => {
    this.setState({
      openSessionAuditLogModal: false
    });
  }

  handleClockOutAlertClick = (event) => {
    this.setState({clockOutDateTime : moment.utc().format('YYYY-MM-DDTHH:mm:ss')},()=>{ this.props.getGeoLocationClockOut(); });    
    Alert.closeAll();
  };

  handleClockOut = (event) => {
    let warningMsg = 'Are you sure you want to clock-out ? You can only do it once. You should be at the location where session is taking place';
    alertConfirmation(warningMsg, {
      html: true,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleClockOutAlertClick       
      },
    });
  };

  handleNewRequest = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
  };

  componentWillReceiveProps(nextProps) {
    // console.log('in soap page ........', nextProps);

    if (nextProps.match.params.encId !== this.props.match.params.encId) {
      // let isAdminUpdateAfterRendered = this.state.isAdminUpdateAfterRendered ? true : false;
      // this.props.getPatientEncounter(this.state.apptid, this.state.encounterId, isAdminUpdateAfterRendered);
    }
    if (nextProps.master_data && this.props.master_data !== nextProps.master_data) {
      this.setState({
        master_data: nextProps.master_data,
        master_CPT: nextProps.master_data.masterCPT,       
      });
    }

    if (this.props.agencyName.toUpperCase() === HELPINGHANDS && nextProps.supervisionTrainingTitleWithoutOJT && this.props.supervisionTrainingTitleWithoutOJT !== nextProps.supervisionTrainingTitleWithoutOJT) {
      this.setState({
        supervisionTrainingTitleWithoutOJT: nextProps.supervisionTrainingTitleWithoutOJT,
      });
    }

    if (nextProps.app_config && this.props.app_config !== nextProps.app_config) {
      let app_config = nextProps.app_config;
      let employee_signRequired = false;
      if (app_config && app_config.length) {
        app_config.forEach((Obj) => {
          if (Obj.configType === 1) {
            switch (Obj.key) {
            case 'CLINICIAN_SIGN':
              employee_signRequired = (Obj.value.toString().toLowerCase() === 'true');
              break;
            default:
              break;
            }
          }
        });
      }
      let isAnySignRequired = employee_signRequired;
      this.setState({
        isAllSigned: !isAnySignRequired,
        signRequired: {
          employee_sign: employee_signRequired,
          client_sign: false,
          guardian_sign: false,
        },
      });
    }

    if (nextProps.saved_patientEncounter && this.props.saved_patientEncounter !== nextProps.saved_patientEncounter) {
      // console.log('saved_patientEncounter...', nextProps.saved_patientEncounter);
      let data = nextProps.saved_patientEncounter.data;
      if (data && data.id) {

        if (!this.state.encounterId) {
          history.push(`/non-billable-soap/${this.state.apptid}/${data.id}/${this.state.isAdminUpdateAfterRendered ? 1 : 0}/0`);
        }

        this.setState({ encounterId: data.id, isSoapCompleted: true, isAllSigned: true });
      }
    }

    if (nextProps.lastUpdatedDate && this.props.lastUpdatedDate !== nextProps.lastUpdatedDate) {
      //console.log('nextProps.lastUpdatedDate before.................', nextProps.lastUpdatedDate)      
      this.setState({ lastUpdatedDate: nextProps.lastUpdatedDate.toString().replace('Z', '') });
      //console.log('this.state.lastUpdatedDate after.................', this.state.lastUpdatedDate)      
    }

    if (nextProps.patientEncouterDetail && this.props.patientEncouterDetail !== nextProps.patientEncouterDetail) {
      // console.log('patientEncouterDetail..', nextProps.patientEncouterDetail);
      let data = nextProps.patientEncouterDetail.data;
      let appointmentData = data.patientAppointment;
      let staffIds = [];
      let staffNames = [];
      let signatureStaffs = [];
      let signatureSupervisee = [];
      appointmentData.appointmentSingleStaff.forEach((staff) => {
        staffNames.push(staff.staffName);
        staffIds.push(staff.staffId);
        signatureStaffs.push({ 'id': staff.staffId, 'value': staff.staffName });
      });

      if(appointmentData.superviseeStaff != '')
        signatureSupervisee.push({ 'id': appointmentData.superviseeStaffId, 'value': appointmentData.superviseeStaff });


      let staffID = staffIds && staffIds.length ? staffIds[0] : null;
      let staffName = staffNames && staffNames ? staffNames.join(',') : '';
      let appointmentTypeName = appointmentData.appointmentTypeName;
      let appointmentTypeIsBillable = appointmentData.isBillable;
      let appointmentDate = showFormatedDate(appointmentData.dateOfService);
      let appointmentTime = showFormattedTime(appointmentData.startDateTime) + ' - ' + showFormattedTime(appointmentData.endDateTime);
      let actualStartTime = showFormattedTime(appointmentData.startDateTime);
      let actualEndTime = showFormattedTime(appointmentData.endDateTime);
      let patientName = appointmentData.patientName;
      let payerName = appointmentData.payerName;
      let PatientLocationID = '';
      let PatientLocationName = appointmentData.address;

      //console.log('appointmentData.............',appointmentData)
      this.setState({
        appointment: appointmentData,
        ParentAppointmentID: appointmentData.parentAppointmentId,
        staffID: staffID,
        staffName: staffName,
        patient_id: appointmentData.patientID,
        patientName: patientName,
        payerName: payerName,
        appointmentTypeName: appointmentTypeName,
        appointmentTypeIsBillable: appointmentTypeIsBillable,
        appointmentDate: appointmentDate,
        actualStartTime: actualStartTime,
        actualEndTime: actualEndTime,
        DateTimeOfVisit: `${appointmentDate}, ${appointmentTime}`,
        PatientLocationName: PatientLocationName,
        PatientLocationID: PatientLocationID,
        DateOfService: appointmentData.startDateTime,
        appointmentStartDateTime: appointmentData.startDateTime,
        appointmentEndDateTime: appointmentData.endDateTime,
        serviceStartTime: appointmentData.startDateTime,
        serviceEndTime: appointmentData.endDateTime,
        showCompleteButton: appointmentTypeIsBillable && this.state.encounterId ? true : false,
        signatureStaffs: signatureStaffs,
        serviceFacility: appointmentData.serviceFacility,
        isDirectService: appointmentData.isDirectService,
        isAdminUpdateAfterRendered: (appointmentData.claimId && appointmentData.canEdit),
        clockInDateTime: appointmentData.clockInDateTime,
        clockOutDateTime: appointmentData.clockOutDateTime,
        signatureSupervisee: signatureSupervisee,
        timeDifference: (appointmentData.timeDifference ? (appointmentData.timeDifference / 60).toFixed(2) : 0),     
        lastUpdatedBy : data.lastUpdatedBy,
        lastUpdatedDate : data.lastUpdatedDate,    
      }, () => {

        if (data && data.id) {
          if (data.encounterSignature) {
            (data.encounterSignature || []).forEach((signObj) => {
              if (signObj.clinicianSign) {
                let signData = {
                  id: signObj.id,
                  Bytes: signObj.clinicianSign,
                  Date: signObj.clinicianSignDate,
                  Name: this.state.staffName,
                  Latitude: signObj.latitude, 
                  Longitude: signObj.longitude,
                };
                this.setState({ EmployeeSign: signData, isAllSigned: true });
              }
              if (signObj.superviseeSign) {
                let data = {
                  id: signObj.id,
                  Bytes: signObj.superviseeSign,
                  Date: signObj.superviseeSignDate,
                  Name: signObj.superviseeName ? signObj.superviseeName : appointmentData.superviseeStaff,
                  Latitude: signObj.latitude, 
                  Longitude: signObj.longitude,
                };                
                this.setState({ SuperviseeSign: data , isAllSigned: true});
              } 
            });
          }

          if (!(this.state.isAdminUpdateAfterRendered && this.props.modifyAfterRenderPermission)) {
            //this.setState({
              // serviceStartTime: data.startDateTime,
              // serviceEndTime: data.endDateTime,
              if(this.props.agencyName.toUpperCase() === HELPINGHANDS && this.props.hasRBTLogin)
                this.setState({isSoapCompleted: false}); 
              else
                this.setState({isSoapCompleted: true});
            //});
          }
        }

        let cptArray = [];
        if (data.patientEncounterServiceCodes && data.patientEncounterServiceCodes.length) {
          data.patientEncounterServiceCodes.forEach((obj, index) => {
            cptArray.push({
              'AuthProcedureCPTLinkId': obj.authProcedureCPTLinkId,
              'AuthorizationNumber': obj.authorizationNumber,
              'ServiceCodeId': obj.serviceCodeId,
              'ServiceCode': obj.serviceCode,
              'Description': obj.description,
              'IsDeleted': obj.isDeleted,
              'Id': obj.id,
              'Modifier1': obj.modifier1,
              'Modifier2': obj.modifier2,
              'Modifier3': obj.modifier3,
              'Modifier4': obj.modifier4,
              'AttachedModifiers': obj.attachedModifiers,
            });
          });
        }

        this.setState({         
          CPTTableData: cptArray,
        },()=>{
          if(this.state.isGenerateClaimAfterRendered)
          {     
            var link = document.getElementById('btnComplete');      
            if(link)      
              link.click();            
          }
        });
      });      
    }

    if (nextProps.clockInLatitude && nextProps.clockInLatitude > 0 && this.props.clockInLatitude !== nextProps.clockInLatitude) {
      let formData = {
        'appointmentId': this.state.apptid,
        'clockInDateTime': this.state.clockInDateTime,
        'clockInLatitude' : nextProps.clockInLatitude || 0.0,
        'clockInLongitude' : nextProps.clockInLongitude || 0.0,
      }
      this.props.saveClockInTimeIntoAppointment(formData);
    }

    if (nextProps.clockOutLatitude && nextProps.clockOutLatitude > 0 && this.props.clockOutLatitude !== nextProps.clockOutLatitude) {
      let formData = {
        'appointmentId': this.state.apptid,
        'clockOutDateTime': this.state.clockOutDateTime,
        'clockOutLatitude' : nextProps.clockOutLatitude || 0.0,
        'clockOutLongitude' : nextProps.clockOutLongitude || 0.0,
      }     
      this.props.saveClockOutTimeIntoAppointment(formData);
    }

  };

  onDateChange(input, value) {
    input.onChange(moment(value).format());
    this.setState({ [input.name]: value });
  };

  // onCompleteEncounter(formProps) {
  //   let isGenerateClaim = true;
  //   this.submitFormData(formProps, isGenerateClaim);
  // }

  onCompleteEncounter(formProps) {
    this.setState({isGenerateClaimAfterRendered : false});
    let encounterSignatures = [];
    if(this.state.EmployeeSign && this.state.SuperviseeSign)
    {
        encounterSignatures = [{
          id: this.state.EmployeeSign.id || null,
          patientEncounterId: this.state.encounterId,
          patientId: null,
          patientSign: null,
          patientSignDate: null,
          staffId: this.state.staffID,
          clinicianSign: this.state.EmployeeSign.Bytes || null,
          clinicianSignDate: this.state.EmployeeSign.Date ? moment.utc().format('YYYY-MM-DDTHH:mm:ss') : null,
          guardianName: null,
          guardianSign: null,
          guardianSignDate: null,
          superviseeName: null,
          superviseeSign: null,
          superviseeSignDate: null,
          latitude: this.props.latitude ? this.props.latitude : 0.0,
          longitude: this.props.longitude ? this.props.longitude : 0.0,
        },
        {
          id: this.state.SuperviseeSign.id || null,
          patientEncounterId: this.state.encounterId,
          patientId: null,
          patientSign: null,
          patientSignDate: null,
          staffId: null,
          clinicianSign: null,
          clinicianSignDate: null,
          guardianName: null,
          guardianSign: null,
          guardianSignDate: null,
          superviseeName: this.state.SuperviseeSign ? this.state.SuperviseeSign.Name : null,
          superviseeSign: this.state.SuperviseeSign ? this.state.SuperviseeSign.Bytes : null,
          superviseeSignDate: this.state.SuperviseeSign ? moment.utc().format('YYYY-MM-DDTHH:mm:ss') : null,
          latitude: this.props.latitude ? this.props.latitude : 0.0,
          longitude: this.props.longitude ? this.props.longitude : 0.0,
        },
      ];
    }
    else if(this.state.EmployeeSign)
    {
        encounterSignatures = [{
          id: this.state.EmployeeSign.id || null,
          patientEncounterId: this.state.encounterId,
          patientId: null,
          patientSign: null,
          patientSignDate: null,
          staffId: this.state.staffID,
          clinicianSign: this.state.EmployeeSign.Bytes || null,
          clinicianSignDate: this.state.EmployeeSign.Date? moment.utc().format('YYYY-MM-DDTHH:mm:ss') : null,
          guardianName: null,
          guardianSign: null,
          guardianSignDate: null,
          superviseeName: null,
          superviseeSign: null,
          superviseeSignDate: null,
          latitude: this.props.latitude ? this.props.latitude : 0.0,
          longitude: this.props.longitude ? this.props.longitude : 0.0,
        },        
      ];
    }
    else if(this.state.SuperviseeSign)
    {
        encounterSignatures = [{
          id: this.state.SuperviseeSign.id || null,
          patientEncounterId: this.state.encounterId,
          patientId: null,
          patientSign: null,
          patientSignDate: null,
          staffId: null,
          clinicianSign: null,
          clinicianSignDate: null,
          guardianName: null,
          guardianSign: null,
          guardianSignDate: null,
          superviseeName: this.state.SuperviseeSign ? this.state.SuperviseeSign.Name : null,
          superviseeSign: this.state.SuperviseeSign ? this.state.SuperviseeSign.Bytes : null,
          superviseeSignDate: this.state.SuperviseeSign ? moment.utc().format('YYYY-MM-DDTHH:mm:ss') : null,
          latitude: this.props.latitude ? this.props.latitude : 0.0,
          longitude: this.props.longitude ? this.props.longitude : 0.0,
        },
      ];
    }
    let CPTcodes = this.state.CPTTableData;
    let isGenerateClaim = false;
    let formData = {
      'Id': this.state.encounterId,
      'PatientID': this.state.patient_id > 0 ? this.state.patient_id : null,
      'AppointmentStartDateTime': this.state.appointmentStartDateTime,
      'AppointmentEndDateTime': this.state.appointmentEndDateTime,
      'PatientAppointmentId': this.state.encounterId || !this.state.appointment.RecurrenceRule ? this.state.apptid : null,
      'ParentAppointmentId': this.state.encounterId ? null : this.state.ParentAppointmentID,
      'DateOfService': this.state.DateOfService,
      'StartDateTime': moment(this.state.serviceStartTime).format('YYYY-MM-DD') + 'T' + moment(this.state.serviceStartTime).format('HH:mm:ss'),
      'EndDateTime': moment(this.state.serviceEndTime).format('YYYY-MM-DD') + 'T' + moment(this.state.serviceEndTime).format('HH:mm:ss'),
      'StaffID': this.state.staffID,
      'ServiceLocationID': this.state.appointment ? this.state.appointment.serviceLocationID : null,
      'OfficeAddressID': this.state.appointment ? this.state.appointment.officeAddressID : null,
      'PatientAddressID': this.state.appointment ? this.state.appointment.patientAddressID : null,
      'CustomAddressID': this.state.appointment ? this.state.appointment.customAddressID : null,
      'CustomAddress': this.state.appointment ? this.state.appointment.customAddress : null,
      'ServiceAddress': this.state.appointment ? this.state.appointment.address : null,
      'NotetypeId': this.state.appointment && this.state.appointment.noteTypeId ? this.state.appointment.noteTypeId : 1,
      'NonBillableNotes': formProps.NonBillableNotes,
      'isBillableEncounter': this.state.appointmentTypeIsBillable ? true : false,
      'encounterSignature': encounterSignatures,
      'PatientEncounterServiceCodes': CPTcodes,
      'TrainingTitleId': formProps.trainingTitleId || null,
    };
    // console.log('submit data =========', JSON.stringify(formData));
    // check for user is Admin and Soap has been rendered ...
    let isAdminUpdateAfterRendered = this.state.isAdminUpdateAfterRendered && this.props.modifyAfterRenderPermission;
    this.props.savePatientEncounter(formData, isGenerateClaim, isAdminUpdateAfterRendered);
  }

  handleOpenSign= () => {
    this.props.getGeoLocation();
    this.setState({ openSign: true, soapPage: true });
  };
  handleCloseSign = () => {
    this.setState({ openSign: false });
  };
  handleAddSign = (formProps) => {

    let signBytes = formProps.signBytes.substring(22);
    let data = {
      id: this.state.EmployeeSign.id,
      Bytes: signBytes,
      Date: moment().format('YYYY-MM-DDTHH:mm:ss'),
      Name: formProps.staffName,
      Latitude: 0.0,
      Longitude: 0.0,
    };
    this.setState({ EmployeeSign: data, isAllSigned: true });
  }

  handleAddSignHIH = (formProps) => {
    
    let signBytes = formProps.signBytes.substring(22);
    let data = {
      Bytes: signBytes,
      Date: moment().format('YYYY-MM-DDTHH:mm:ss'),
      Name: '',
      Latitude: 0.0,
      Longitude: 0.0,
    };
    
    if(this.props.hasRBTLogin) {
      switch (formProps.Signee) {        
        case 1:
            data.id = this.state.SuperviseeSign.id || null;
            data.Name = extractNameFromArray(this.state.signatureSupervisee, formProps.SuperviseeStaffId);
            data.Latitude = this.props.latitude;
            data.Longitude = this.props.longitude;
            this.setState({ SuperviseeSign: data });           
            break;
        default:
          break;
        }
    }
    else {
      switch (formProps.Signee) {
        case 1:
          data.id = this.state.EmployeeSign.id || null;
          data.Name = extractNameFromArray(this.state.signatureStaffs, formProps.StaffID);
          data.Latitude = this.props.latitude;
          data.Longitude = this.props.longitude;
          this.setState({ EmployeeSign: data });
         
          break;        
        case 2:
            data.id = this.state.SuperviseeSign.id || null;
            data.Name = extractNameFromArray(this.state.signatureSupervisee, formProps.SuperviseeStaffId);
            data.Latitude = this.props.latitude;
            data.Longitude = this.props.longitude;
            this.setState({ SuperviseeSign: data });           
            break;
        default:
          break;
        }
    }
  
    this.setState({ isAllSigned: true });
  }

  // componentDidUpdate() {
  //   if(this.state.isGenerateClaimAfterRendered)
  //   {     
  //     var link = document.getElementById('btnComplete');      
  //     if(link)      
  //       link.click();            
  //   }    
  // }
  
  render() {
    const { handleSubmit, isStartedFromMobile } = this.props;
    const isMobileDraft =
      isStartedFromMobile &&
      this.state.isSavedAsDraft &&
      !this.state.isSoapCompleted &&
      !this.state.isSessionPending &&
      !(this.state.isAdminUpdateAfterRendered && this.props.modifyAfterRenderPermission);
    //const patientInfo = this.state.patient_id > 0 ? (<PatientInfo patientId={this.state.patient_id} />) : null;
    const signatureModal = this.state.openSign ?
      this.props.agencyName.toUpperCase() === HELPINGHANDS ? 
       (<SignatureWithSuperviseeModal hasRBTLogin = {this.props.hasRBTLogin} superviseeStaffId={this.state.superviseeStaffId} staffID={this.state.staffID} staffs={this.state.signatureStaffs} supervisee={this.state.signatureSupervisee} closeDialog={this.handleCloseSign} handleAddSign={this.handleAddSignHIH.bind(this)} /> )
      : (<SignatureModal staffName={this.state.staffName} closeDialog={this.handleCloseSign} handleAddSign={this.handleAddSign.bind(this)} />)
      : null;
    let totalUnitsConsumed = (this.state.get_soap && this.state.get_soap.unitsConsumed) || 0;
    let canOnlyAddSignForTheirNotes = true;
    if (this.props.canOnlyAddSignForTheirNotes && !(this.state.isAdminUpdateAfterRendered && this.props.modifyAfterRenderPermission)) {
      canOnlyAddSignForTheirNotes = this.props.currentLoginUserId === this.state.staffID;
    }
    return (
      <div>
        <h2 className="page_title">Visit Details</h2>
        {/* {patientInfo} */}
        {signatureModal}
        {this.state.openSessionAuditLogModal ? <SessionAuditLogModal appointmentId={this.state.apptid} isBillableSession={false} closeDialog={() => this.handleCloseSessionAuditLogModal()}/> : null}
        <div className="clearfix"></div>
        <div className="readmin-panel mt-15">
          <div className="panel-body">
            <form className="readmin-form custom_form">
              <div className="row">
                {/* Show yellow warning if draft started from mobile */}
                {isMobileDraft && (
                  <div style={{
                    color: '#e6c200',
                    padding: '0px 16px 16px',
                    marginBottom: '16px',
                    fontWeight: 'bold',
                    textAlign: 'center',
                  }}>
                    This session note was started from the mobile app, please complete from your device.
                  </div>
                )}
                <div className="col-4 col-sm-4 col-md-4">
                  {/* {this.state.isGenerateClaimAfterRendered ?
                    <div className={'alert alert-danger-soap update-pwd'}>
                        <strong>CLICK ON SAVE TO SAVE CHANGES</strong>
                    </div>
                    :  */}
                    <CommonButton className="mb-20" label="Go back to scheduler" primary={true} onTouchTap={this.handleCancel} />
                  {/* } */}
                </div>
                <div className="col-4 col-sm-4 col-md-4 btn_rt">                    
                    <CommonButton className="mb-20" label="Clock In" disabled={this.state.clockInDateTime ? true : false} primary={true} onTouchTap={this.handleClockIn} />                    
                </div>
                <div className="col-4 col-sm-4 col-md-4 btn_rt">                    
                    <CommonButton className="mb-20" label="Clock Out" disabled={this.state.clockOutDateTime ? true : false} primary={true} onTouchTap={this.handleClockOut} />                    
                </div>
              </div>
              {this.state.lastUpdatedBy && <div className="row">
                <div className="col-12 col-sm-12 col-md-12">
                <div className="client_profile">                              
                    <div className="userlinks">
                      {/* {console.log('this.state.lastUpdatedDate...............',this.state.lastUpdatedDate)}*/}
                    <p><a href="#" onClick={(e) => this.handleOpenSessionAuditLog(e)}><u>Last Edited</u>:</a> {showFormatedDateandTimeForSessionLogs(this.state.lastUpdatedDate)} By {this.state.lastUpdatedBy}</p>                                                                 
                    </div>                                           
                </div>
                </div>
              </div>}
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title no_margin mb-20">
                    <h3>Appointment</h3>
                    <i className="flaticon flaticon-medical-4"></i>
                  </div>
                </div>
                <div className="col-sm-12 ml-20">
                  <div className="col-sm-12 soap_content">
                    <div className="soap_detail detail_wd">
                      <p>
                        <b>Organization Name :</b> <span>{this.props.organizationName ? this.props.organizationName.toUpperCase() : '-'}</span>
                      </p>
                      <p>
                        <b>Appointment :</b> <span>{this.state.appointmentTypeName ? this.state.appointmentTypeName : '-'}</span>
                      </p>
                      <p>
                        <b>Appointment Date :</b> <span>{this.state.appointmentDate ? this.state.appointmentDate : '-'}</span>
                      </p>
                      <p>
                        <b>Actual start time:</b> <span>{this.state.actualStartTime ? this.state.actualStartTime : '-'}</span>
                      </p>
                      <p>
                        <b>Actual end time:</b> <span>{this.state.actualEndTime ? this.state.actualEndTime : '-'}</span>
                      </p>
                      <p>
                        <b>Provider Name/Credentials :</b> <span>{this.state.staffName ? this.state.staffName : '-'}</span>
                      </p>
                      <p>
                        <b>Place of Service :</b> <span>{this.state.serviceFacility || '-'}</span>
                      </p>
                      <p>
                        <b>Service Type :</b> <span>{this.state.isDirectService ? 'Direct' : 'Indirect'}</span>
                      </p>
                      <p className="wd-100">
                        <b>Service Location :</b> <span>{this.state.PatientLocationName ? this.state.PatientLocationName : '-'}</span>
                      </p>
                         <p><b>Client Diagnosis (ICD-10 CODE):</b> <span>{(this.state.diagnosisArray && this.state.diagnosisArray.filter((obj) => !obj.IsDeleted).length > 0) ? this.state.diagnosisArray.filter((obj) => !obj.IsDeleted).map((obj) => obj.ICDCode).join(', ') : '-'}</span>
                      </p>
                      <p>
                        <b>Unit Billed :</b> <span>{totalUnitsConsumed}</span>
                      </p>
                      <p>
                        <b>Payer Name :</b> <span>{this.state.payerName ? this.state.payerName : '-'}</span>
                      </p>
                      <p>
                        <b>Client Name :</b> <span>{this.state.patientName ? this.state.patientName : '-'}</span>
                      </p>
                      <p>
                        <b>Session Duration (In Hrs):</b> <span>{this.state.timeDifference}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="clearfix"></div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h3>Service</h3>
                    <i className="flaticon flaticon-time-1"></i>
                  </div>
                </div>
                <div className="col-sm-6">
                  <Field
                    name="serviceStartTime"
                    placeholder="Start Time"
                    fullWidth={true}
                    // disabled={this.state.isSoapCompleted}
                    disabled={isMobileDraft || true}
                    component={renderTimePicker}
                    selected={this.state.serviceStartTime}
                    onDateChange={this.onDateChange}

                  />
                </div>
                <div className="col-sm-6">
                  <Field
                    name="serviceEndTime"
                    placeholder="End Time"
                    // disabled={this.state.isSoapCompleted}
                    disabled={isMobileDraft || true}
                    component={renderTimePicker}
                    selected={this.state.serviceEndTime}
                    onDateChange={this.onDateChange}
                    fullWidth={true}
                  />
                </div>
              </div>
              <div className ="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h3>Notes</h3>
                    <i className="flaticon flaticon-interface-2"></i>
                  </div>
                </div>
                {this.props.agencyName.toUpperCase() === HELPINGHANDS ? 
                <div className='col-sm-12 require mt-35'>
                  <Field
                      name="trainingTitleId"
                      label="Training Title"
                      handleNewRequest={this.handleNewRequest}
                      options={this.state.supervisionTrainingTitleWithoutOJT}
                      disabled={isMobileDraft || this.state.isSoapCompleted}
                      component={renderAutoCompleteSingleSelect}
                      validate={validateTrainingTitleId}
                    />
                </div>: null}
                <div className={'col-sm-12 require'} >
                  <Field
                    name="NonBillableNotes"
                    type="text"
                    fullWidth={true}
                    label="Notes"
                    rows={5}
                    disabled={isMobileDraft || this.state.isSoapCompleted}
                    validate={validateNonBillableNotes}
                    autoHeight={true}
                    component={renderTextArea}
                  />
                </div>
              </div>
            </form>
            <div className="row">
              <div className="col-sm-12 pt20 btn_rt scroll_btn">
                <CancelButton onTouchTap={this.handleCancel} />
                {canOnlyAddSignForTheirNotes ?
                  <CommonButton disabled={isMobileDraft} className="soapmodal_btn ml-3" label="Add Sign" primary={true} onTouchTap={this.handleOpenSign} />
                : null}
                {!this.state.isSoapCompleted ?
                  <CommonButton id="btnComplete" className="ml-3 soapmodal_btn" label={"Complete"} primary={true} disabled={isMobileDraft || !this.state.isAllSigned} onClick={handleSubmit(this.onCompleteEncounter)} />
                  : ''}
              </div>
            </div>

            { this.state.EmployeeSign.Bytes  || this.state.SuperviseeSign.Bytes ?
              <div className="row">
                <div className="col-12">
                  <div className="panel_title mt-24  mb-20">
                    <h3>Signature</h3>
                    <i className="flaticon flaticon-medical-1"></i>
                  </div>
                </div>
                {
                  this.state.EmployeeSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageEmployee">

                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.EmployeeSign.Bytes}`} alt={''} />
                              <h3>{this.state.EmployeeSign.Name} <span>(Employee)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.EmployeeSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.EmployeeSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.EmployeeSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    : ''
                }
                {
                  this.state.SuperviseeSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageSupervsiee">

                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.SuperviseeSign.Bytes}`} alt={''} />
                              <h3>{this.state.SuperviseeSign.Name} <span>(RBT)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.SuperviseeSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.EmployeeSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.EmployeeSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    : ''
                }
              </div>
              : ''}

          </div>
        </div>
      </div>
    );
  }
};
Soap = reduxForm({
  form: 'soapForm',
  enableReinitialize: true,
})(Soap);

function mapStateToProps(state) {
  // Start For Role Permission
  let userActionPermission = [],lastUpdatedBy = '', lastUpdatedDate = '';
  if (state.login.userPermission) {
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'SCHEDULING');
    let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === 'SCHEDULING_LIST' && obj.moduleId === userModulePermission[0].moduleId);
    userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
  }

  let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission
  let hasRBTLogin = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.roleName === 'RBT' ? true : false; // For Role Permission

  let addPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_ADDCODES_IN_SOAP')[0].permission : false;
  let deletePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_DELETECODES_IN_SOAP')[0].permission : false;
  let modifyAfterRenderPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_MODIFYAPPOINTMENT_AFTER_RENDERING')[0].permission : false;
  let canOnlyAddSignForTheirNotes = hasDefaultAccess ? false : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_PRACTITIONER_CAN_ONLY_ADD_SIGN_FOR_THEIR_OWN_NOTES')[0].permission : false;

  // End For Role Permission

  let initialData = null;
  if (state.nonBillableSoap.patientEncouterDetail) {
    let obj = state.nonBillableSoap.patientEncouterDetail.data;
    if (obj && obj.id) {
      lastUpdatedBy = obj.lastUpdatedBy;
      lastUpdatedDate = obj.lastUpdatedDate;
      initialData = {
        // serviceStartTime: obj.startDateTime,
        // serviceEndTime: obj.endDateTime,
        trainingTitleId: obj.trainingTitleId,
        NonBillableNotes: obj.nonBillableNotes,      
      };
    }
  }

  if (state.nonBillableSoap.saved_patientEncounter && state.nonBillableSoap.saved_patientEncounter) {
    //console.log('state.soap.saved_soap.data................',state.soap.saved_soap.data);
    let obj = state.nonBillableSoap.saved_patientEncounter.data;    
    lastUpdatedDate = obj.lastUpdatedDate;
  }
   // console.log('state.nonBillableSoap................',state.nonBillableSoap);
    // console.log('state.nonBillableSoap................',state.nonBillableSoap);

  let app_config = state.appConfig.appConfigList ? state.appConfig.appConfigList.data : null;

  return {
    app_config: app_config,
    userLocationList: state.login.userLocationList,
    loading: state.nonBillableSoap.loading,
    appointment: state.nonBillableSoap.appointment,
    patientEncouterDetail: state.nonBillableSoap.patientEncouterDetail,
    saved_patientEncounter: state.nonBillableSoap.saved_patientEncounter,
    initialValues: initialData,
    currentLoginUserId: state.login.loginUserInfo && state.login.loginUserInfo.id,
    hasDefaultAccess: hasDefaultAccess,
    addPermission: addPermission,
    deletePermission: deletePermission,
    modifyAfterRenderPermission: modifyAfterRenderPermission,
    canOnlyAddSignForTheirNotes: canOnlyAddSignForTheirNotes,
    latitude: state.appConfig.latitude,
    longitude: state.appConfig.longitude,
    clockInLatitude: state.appConfig.clockInLatitude,
    clockInLongitude: state.appConfig.clockInLongitude,
    clockOutLatitude: state.appConfig.clockOutLatitude,
    clockOutLongitude: state.appConfig.clockOutLongitude,   
    master_data: state.soap.master_data,
    organizationName: state.login.organizationDetails && state.login.organizationDetails.organizationName ? state.login.organizationDetails.organizationName : '',
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
    hasRBTLogin: hasRBTLogin,
    supervisionTrainingTitleWithoutOJT: state.soapReducerHIH.staffTrainingTitles && state.soapReducerHIH.staffTrainingTitles.data ? state.soapReducerHIH.staffTrainingTitles.data : null,
    lastUpdatedBy: lastUpdatedBy,
    lastUpdatedDate: lastUpdatedDate,
    isStartedFromMobile: !!(state.soap.get_soap && state.soap.get_soap.data && state.soap.get_soap.data.isStartedFromMobile),
  };
}

export default connect(mapStateToProps, { getAppConfigList, getAppointmentById, getPatientEncounter, savePatientEncounter, getGeoLocation, getGeoLocationClockIn, saveClockInTimeIntoAppointment, saveClockOutTimeIntoAppointment, getStaffTrainingTitlesForHIH, getGeoLocationClockOut })(Soap);



// WEBPACK FOOTER //
// ./src/modules/scheduling/components/nonBillableSoap/index.js